import script from "./uploadProductDeals.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadProductDeals.vue?vue&type=script&setup=true&lang=js"

import "./uploadProductDeals.vue?vue&type=style&index=0&id=1d3ad28b&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3ad28b"]])

export default __exports__